import React from 'react';
import { Zap } from 'lucide-react';
import type { GS1ScanType } from '../../utils/gs1Parser';

interface Props {
  rawBarcode: string;
  scanType: GS1ScanType | null;
  onRawChange: (value: string) => void;
  onParse: () => void;
}

const scanTypeBadge: Record<GS1ScanType, { label: string; color: string }> = {
  twoReads: { label: 'Two Reads', color: 'bg-orange-100 text-orange-700' },
  gs1_128: { label: 'GS1-128', color: 'bg-blue-100 text-blue-700' },
  dataMatrix: { label: 'DataMatrix', color: 'bg-purple-100 text-purple-700' },
  simpleEan: { label: 'EAN Simples', color: 'bg-green-100 text-green-700' },
  unknown: { label: 'Desconhecido', color: 'bg-gray-100 text-gray-600' },
};

export function BarcodeInputSection({ rawBarcode, scanType, onRawChange, onParse }: Props) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onParse();
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
      <h2 className="text-lg font-semibold text-gray-800 mb-3">Codigo de Barras</h2>
      <textarea
        value={rawBarcode}
        onChange={(e) => onRawChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Cole ou digite a string do codigo de barras aqui... Ex: (01)07891234567890(17)260630(10)L1234"
        className="w-full h-24 px-4 py-3 font-mono text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 resize-none"
      />
      <div className="flex items-center gap-3 mt-3">
        <button
          onClick={onParse}
          disabled={!rawBarcode.trim()}
          className="flex items-center gap-2 px-5 py-2.5 bg-teal-600 text-white rounded-lg hover:bg-teal-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors font-medium"
        >
          <Zap className="w-4 h-4" />
          Parsear
        </button>
        {scanType && (
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${scanTypeBadge[scanType].color}`}>
            {scanTypeBadge[scanType].label}
          </span>
        )}
      </div>
    </div>
  );
}
